import React, { Component } from "react";
import axios from "axios";
import { Route, Switch } from "react-router-dom";
import { withAuth0 } from "@auth0/auth0-react";
import LandingPage from "./components/LandingPage/LandingPage";
import Generator from "./components/Generator";
import PublicFeed from "./components/PublicFeed";
import DataPrivacy from "./components/DataPrivacy";
import TermsOfService from "./components/TermsOfService";
import ProtectedRoute from "./components/auth/protected-route";
import UserConsent from "./components/UserConsent"
import DeleteAccountRequest from "./components/DeleteAccountRequest";

import "./App.css";
import ImageLoader from "./components/common/ImageLoader";

class App extends Component {
  state = {
    user: {},
    authToken: "",
    history: [],
    auth_user: {},
    postHistory: [],
    totalImages: 0,
    topPosts: [],
    loading: false,
  }

  getTopPosts = (token) => {
    axios.get(`${process.env.REACT_APP_BACKEND}/get-top-posts`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(async (response) => {
        this.setState({ topPosts: response.data.top_posts })
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      })
  }

  getImages = (imageId) => {
    const formData = new FormData();
    formData.append("_id", imageId)
    axios.post(`${process.env.REACT_APP_BACKEND}/get_images`, formData,
      {
        headers: {
          Authorization: `Bearer ${this.state.authToken}`
        }
      })
      .then(async (response) => {
        const images = response.data.history;
        const history = [...this.state.history, ...images]
        this.setState({ loading: false, history: history, totalImages: response.data.history_size });
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      })
  }

  getPosts = (postId, mode) => {
    const formData = new FormData();
    formData.append("_id", postId)
    formData.append("mode", mode)
    axios.post(`${process.env.REACT_APP_BACKEND}/get_posts`, formData,
      {
        headers: {
          Authorization: `Bearer ${this.state.authToken}`
        }
      })
      .then(async (response) => {
        const posts = response.data.post_history;
        let postHistory;
        if (mode === "newest") {
          postHistory = [...posts, ...this.state.postHistory]
        }
        if (mode === "oldest") {
          postHistory = [...this.state.postHistory, ...posts]
        }
        this.setState({ loading: false, postHistory: postHistory });
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      })
  }

  handleDeletePost = (postId) => {
    const formData = new FormData();
    formData.append("_id", postId)
    axios.post(`${process.env.REACT_APP_BACKEND}/delete-post`, formData,
      {
        headers: {
          Authorization: `Bearer ${this.state.authToken}`
        }
      })
      .then(async (response) => {
        let postHistory = [...this.state.postHistory];
        postHistory = postHistory.filter(item => item._id !== postId)
        this.setState({ postHistory: postHistory });
      })
      .catch((error) => {
        console.log(error)
      })
  }

  handleLikes = (postId) => {

    const formData = new FormData();
    formData.append("_id", postId)
    axios.post(`${process.env.REACT_APP_BACKEND}/post_like`, formData,
      {
        headers: {
          Authorization: `Bearer ${this.state.authToken}`
        }
      })
      .then(async (response) => {
        const post = response.data;
        const postHistory = [...this.state.postHistory];
        const index = postHistory.findIndex(item => item._id === post._id)
        postHistory[index] = response.data;

        const topPosts = [...this.state.topPosts];
        const indexTop = topPosts.findIndex(item => item._id === post._id)
        topPosts[indexTop] = response.data;

        this.setState({ loading: false, postHistory: postHistory, topPosts: topPosts });
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loading: false })
      })
  }

  updateHistory = (imageData) => {
    this.setState((prev) => ({
      history: [imageData, ...prev.history]
    }))
  }

  removeFromHistory = (imageId, imageHash) => {
    let history = [...this.state.history];
    history = history.filter(item => item._id !== imageId);
    let postHistory = [...this.state.postHistory];
    postHistory = postHistory.filter(item => !item.imageHash.includes(imageHash));
    this.setState({ history: history, postHistory: postHistory });
  }

  updateUser = (userData) => {
    this.setState({ user: userData })
  }

  async componentDidUpdate(prevProps, prevState) {
    const { user, isAuthenticated, getAccessTokenSilently } = this.props.auth0;
    if (isAuthenticated && !prevProps.auth0.isAuthenticated) {
      const token = await getAccessTokenSilently();
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND}/register`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
        this.setState({
          authToken: token,
          auth_user: user,
          user: response.data.account,
          history: response.data.history,
          postHistory: response.data.postHistory,
          totalImages: response.data.history_size,
        })
      } catch (error) { console.log(error) }

      this.getTopPosts(token);
    }

  }

  async componentDidMount() {

    const { user, isAuthenticated, getAccessTokenSilently } = this.props.auth0;
    if (isAuthenticated) {
      const token = await getAccessTokenSilently();
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND}/register`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
        this.setState({
          authToken: token,
          auth_user: user,
          user: response.data.account,
          history: response.data.history,
          postHistory: response.data.postHistory,
          totalImages: response.data.history_size,
        })
      } catch (error) { console.log(error) }

      this.getTopPosts(token);
    }

  }

  deleteAccount = () => {
    this.setState({ loading: true })
    axios.post(`${process.env.REACT_APP_BACKEND}/delete_account`, {},
      {
        headers: {
          Authorization: `Bearer ${this.state.authToken}`
        }
      })
      .then(async (response) => {
        if (response.data.error) {
          console.log(response.data.error)
          alert("Operation Failed, contact support at artblastai@scifork.com")
        } else {
          this.setState({ loading: false })
          alert("Operation Succeed. Your account has been deleted")
          window.location.replace("https://app.artblastai.com")
        }
      })
      .catch((error) => {
        console.log(error)
        alert("Operation Failed. Try again later or contact support at artblast@scifork.com")
        this.setState({ loading: false })
      })

  }

  render() {
    return (
      <React.Fragment>

        <Switch>
          <ProtectedRoute
            path='/generate'
            auth0={this.props.auth0}
            user={this.state.user}
            auth_user={this.state.auth_user}
            updateUser={this.updateUser}
            token={this.state.authToken}
            updateHistory={this.updateHistory}
            imgHistory={this.state.history}
            postHistory={this.state.postHistory}
            getImages={this.getImages}
            totalImages={this.state.totalImages}
            removeFromHistory={this.removeFromHistory}
            component={Generator}
            deleteAccount={this.deleteAccount}
          />

          <ProtectedRoute
            path='/feed'
            auth0={this.props.auth0}
            user={this.state.user}
            auth_user={this.state.auth_user}
            token={this.state.authToken}
            postHistory={this.state.postHistory}
            handleLikes={this.handleLikes}
            getPosts={this.getPosts}
            component={PublicFeed}
            handleDeletePost={this.handleDeletePost}
            topPosts={this.state.topPosts}
            updateUser={this.updateUser}
            deleteAccount={this.deleteAccount}
          />

          <Route
            path="/privacy-policy"
            component={DataPrivacy}
          />

          <Route
            path="/terms-of-service"
            component={TermsOfService}
          />

          <Route
            path='/user-consent'
            auth0={this.props.auth0}
            render={(props) => {
              return <UserConsent {...props} {...this.props} />
            }
            }
          />

          <Route
            path='/delete_account_request'
            component={DeleteAccountRequest}
          />


          <Route
            path='/'
            auth0={this.props.auth0}
            render={(props) => {
              return <LandingPage {...props} {...this.props} />
            }
            }
          />
        </Switch>
        {this.state.loading && <ImageLoader />}
      </React.Fragment>

    );
  }
}


export default withAuth0(App);
